<div class="vadtallogin-page">
    <div class="container">
        <div class="row">            
            <div class="col-lg-6 col-12 order-lg-0 order-2"> 
                <!-- <div>
                    <a href=""><img src="../../../assets/img/logo.svg" alt="logo" class="img-fluid loginlogo"></a>
                </div>               -->
                <div class="login-content">
                    <img src="../../../assets/img/logo.svg" alt="logo" class="img-fluid loginlogo">
                    <h3 class="caption-login mb-3">{{forgotPasswordconstant.FORGOT_PASSWORD}}</h3>
                    <p>{{forgotPasswordconstant.HEADER_TEXT}}</p>
                    <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">
                        <div class="form-group mb-4">
                            <label for="floatingInput">{{forgotPasswordconstant.EMAIL}}<span class="asterisk">*</span></label>
                            <input formControlName="emailAddress" type="Email" class="form-control"
                                placeholder="Enter your Email ID" />                                
                            <span class="text-danger" *ngIf="submitted && forgotPasswordFormControl['emailAddress'].errors?.['required']">Email is
                                required</span>
                            <span class="text-danger" *ngIf="submitted && forgotPasswordFormControl['emailAddress'].errors?.['pattern']">Email is invalid</span>
                        </div>
                        <button class="btn btn-primary login-btn mt-3 mb-3" type="submit">{{forgotPasswordconstant.NEXT}}</button>
                        <div class="backtologin text-center mt-3"><a (click)="goLogin()"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                          </svg>&nbsp;&nbsp;{{forgotPasswordconstant.BACK_TO_LOGIN}}</a></div>                        
                    </form>                                       
                </div>
            </div>
            <div class="col-lg-6 col-12 order-lg-0 order-1">
                <div class="login-rightside">
                    <img src="../../../../assets/img/login-rightimg.jpg" alt="login rightimg" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</div>